import React from 'react';
import BaseSkeleton from './base-skeleton';
import SkeletonCommunity from './skeleton-community';
import { useTheme } from '../../context/theme-context';

const SkeletonCommunityPage: React.FC = () => {
  const { isDarkMode } = useTheme();
  
  return (
    <div className="w-full bg-white dark:bg-neutral-800 min-h-screen">
      {/* Top bar skeleton */}
      <div className={`w-full ${isDarkMode ? 'bg-neutral-800' : 'bg-white'} border-b dark:border-gray-700`}>
        <div className="flex items-center justify-between px-4 py-3">
          <BaseSkeleton variant="rounded" width="100px" height="32px" />
          <BaseSkeleton variant="circular" width="40px" height="40px" />
        </div>
      </div>

      {/* Header section skeleton */}
      <div className="w-full bg-white dark:bg-neutral-800 flex items-center justify-between py-3 px-4">
        <BaseSkeleton variant="text" width="120px" height="28px" />
        <BaseSkeleton variant="circular" width="32px" height="32px" />
      </div>

      {/* User communities section skeleton */}
      <div className="mt-2">
        <div className="px-4 mb-2">
          <BaseSkeleton variant="text" width="140px" height="20px" />
        </div>
        <SkeletonCommunity variant="user" count={3} />
      </div>

      {/* Recommended communities section skeleton */}
      <div className="mt-4">
        <div className="px-4 mb-2">
          <BaseSkeleton variant="text" width="180px" height="20px" />
        </div>
        <SkeletonCommunity variant="recommended" count={3} />
      </div>
    </div>
  );
};

export default SkeletonCommunityPage;